import { Lock, LockOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export interface VisibilityToggleIconProps {
  /** Current visibility: internal (closed lock) or shared (open lock) */
  visibility: "internal" | "shared";
  onClick: () => void;
  disabled?: boolean;
  iconSize?: "sm" | "md";
  className?: string;
}

const iconSizes = { sm: "h-4 w-4", md: "h-5 w-5" };

export function VisibilityToggleIcon({
  visibility,
  onClick,
  disabled = false,
  iconSize = "md",
  className = "",
}: VisibilityToggleIconProps) {
  const isInternal = visibility === "internal";
  const popoverText = isInternal
    ? "Interno. Alterar para compartilhado"
    : "Compartilhado. Alterar para interno";

  const sizeClass = iconSizes[iconSize];
  const colorClass = isInternal
    ? "text-amber-600 dark:text-amber-500 border-amber-200 dark:border-amber-800 hover:border-amber-400 dark:hover:border-amber-600 hover:text-amber-700 dark:hover:text-amber-400"
    : "text-green-600 dark:text-green-500 border-green-200 dark:border-green-800 hover:border-green-400 dark:hover:border-green-600 hover:text-green-700 dark:hover:text-green-400";

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={() => {
              if (!disabled) onClick();
            }}
            disabled={disabled}
            className={`${colorClass} ${className}`}
            aria-label={popoverText}
          >
            {isInternal ? (
              <Lock className={sizeClass} strokeWidth={1.5} />
            ) : (
              <LockOpen className={sizeClass} strokeWidth={1.5} />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">
          {popoverText}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
